export default {
  SET_API_URL (state, api) {
    state.api = api
  },
  SET_APP_NAME (state, name) {
    state.appName = name
  }
}



// WEBPACK FOOTER //
// ./src/store/settings/mutations.js